<template>
  <div id="header">
    <div class="logo">
      <img src="@/common/image/login_logo.png">
    </div>
    <Menu></Menu>
    <Operation id="operation"></Operation>
  </div>
</template>

<script>
import Operation from "@/components/layout/Operation.vue";
import Menu from '@/components/layout/Menu.vue'
import axios from "axios";
export default {
  data() {
    return {}
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    fetch() {
      fetchData()
        .then((data) => {
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    up() {
      axios.get("http://active.ruisizt.com/aaaa", {
        timeout: 1000,
      });
    },
  },
  components: {
    Operation,
    Menu
  },
};
</script>
<style scoped lang="scss">
#header {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  height: 60px;
  box-sizing: border-box;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 100;
}

.menu {
  background: #dddddd;
}

#operation {
  flex: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  color: #000;
}
.logo {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  color: #fff;
  font-weight: 550;
  text-align: center;
  font-size: 25px;
  padding-left: 20px;

  img {
    width: 40px;
    display: flex;
    margin: 0 auto;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue